import React, { useEffect, useState } from 'react';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const updateVisibility = () => setVisible(window.scrollY > 360);
    updateVisibility();
    window.addEventListener('scroll', updateVisibility, {
      passive: true
    });
    return () => window.removeEventListener('scroll', updateVisibility);
  }, []);
  const scrollToCheckout = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  if (!visible) {
    return null;
  }
  return <div className="fixed bottom-0 left-0 right-0 z-40 border-t border-brand-creamDark bg-white/95 px-4 py-3 shadow-[0_-4px_16px_rgba(0,0,0,0.08)] backdrop-blur" data-id="element-157">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-4" data-id="element-158">
        <div className="hidden sm:block" data-id="element-159">
          <p className="font-serif font-bold text-brand-text" data-id="element-160">
            Yoga Pronta — Kit Completo
          </p>
          <p className="text-sm text-brand-gray" data-id="element-161">
            <span className="line-through" data-id="element-162">Valore € 146</span>{' '}
            <span className="font-bold text-brand-green" data-id="element-163">→ € 19</span>
          </p>
        </div>
        <button onClick={scrollToCheckout} className="w-full rounded-full bg-brand-green px-6 py-3.5 text-sm font-bold uppercase tracking-wide text-white shadow-md transition-colors hover:bg-brand-greenDark sm:w-auto" data-id="element-164">
          <span className="sm:hidden" data-id="element-165">€ 19 · Voglio Yoga Pronta</span>
          <span className="hidden sm:inline" data-id="element-166">SÌ, VOGLIO YOGA PRONTA</span>
        </button>
      </div>
    </div>;
}